<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin"></i> Loading
  </div>
  <div v-else class="animated fadeIn mb-5">
    <basic-heading v-if="schedule" class="mb-4">
      <span class="float-left mr-2">{{ `${schedule.name()} Results` }}</span>
      <badge-batch :badge_collection="header_bages"></badge-batch>
      <template #right-content>
        <header-button-group
          :button_config="button_config"
        ></header-button-group>
      </template>
    </basic-heading>

    <b-tabs v-if="processes.length" fill>
      <b-tab
        v-for="(process, index) in processes"
        :key="index"
        :title="process.process.name"
      >
        <schedule-process-results
          :process_schedule="process"
          :tasks="process.tasks"
        ></schedule-process-results>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import BadgeBatch from "@/components/shared/BadgeBatch";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import ScheduleProcessResults from "@/components/lab/schedule/ScheduleProcessResults";
import AnalysisCollection from "@/collections/lab/AnalysisCollection";
import ScheduleModel from "@/models/lab/ScheduleModel";
import { getModel } from "@/shared/fetch-utils";

export default {
  name: "ScheduleResults",
  components: {
    BadgeBatch,
    BasicHeading,
    HeaderButtonGroup,
    ScheduleProcessResults,
  },
  props: {
    model: {
      type: ScheduleModel,
      default: () => null,
    },
  },
  data() {
    return {
      loading: true,
      schedule_id: this.$route.params.schedule_id || null,
      schedule: null,
      processes: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-arrow-left",
            linkto: `/schedules/${this.schedule_id}`,
            title: "View",
            variant: "info",
          },
        ],
      };
    },
    header_bages() {
      return this.processes
        ? this.processes.map(({ process }) => process.name)
        : [];
    },
  },
  methods: {
    formTask(task, process) {
      const task_instances =
        process.process_schedule_instrument_instances.filter(
          ({ process_task_id }) => process_task_id === task.id
        );
      const instances = task_instances.map(({ instrument_instance_id }) =>
        task.instrument_instances.find(
          ({ id }) => id === instrument_instance_id
        )
      );

      const samples = process.instrument_instance_schedules.filter(
        ({ schedulable_task_id }) => schedulable_task_id === task.id
      );
      const analyses = task.analyses.reduce((acc, cur) => {
        acc.add(cur);
        return acc;
      }, new AnalysisCollection());

      return { task, samples, instances, analyses };
    },
    formProcess(process) {
      return {
        process: process.schedulable_process,
        tasks: process.schedulable_process.schedulable_tasks.map((task) =>
          this.formTask(task, process)
        ),
      };
    },
    async init() {
      this.loading = true;

      this.schedule = await getModel({
        model_type: "schedule",
        id: this.schedule_id,
        message: this.$bvToast,
      });

      this.processes = this.schedule.process_schedules.map((process) =>
        this.formProcess(process)
      );

      this.loading = false;
    },
  },
  created() {
    this.init();
  },
};
</script>
